import React from 'react'
import * as yup from 'yup'
import CheckInStep from '../steps/checkIn'
import UserInfo from '../steps/userInfo'
import PaymentStep from '../steps/paymentStep'
import Axios from 'axios'
import { toLower, upperFirst, toString } from 'lodash'
import { CardNumberElement } from '@stripe/react-stripe-js'
import TagManager from 'react-gtm-module'
import Sentry from '../utils/Sentry'
import i18next from 'i18next'

const language = i18next.language || 'en'

export const bookingStep = [
  {
    schema: yup.object().shape({
      start_date: yup.date().required(),
      over12Months: yup.string().required(),
      end_date: yup.date().nullable().when('over12Months', {
        is: 'under',
        then: yup.date().required(),
      }),
      no_guest: yup
        .number()
        .typeError({ translation: 'errors:number' })
        .required('errors:required')
        .min(1, { data: { min: 1 }, translation: 'errors:min' })
        .max(9, { data: { max: 9 }, translation: 'errors:max' }),
    }),
    form: (props) => <CheckInStep {...props} />,
  },
  {
    schema: yup.object().shape({
      tenant_age: yup.number().required(),
      tenant_gender: yup.string().required(),
      tenant_reason: yup.string().required(),
      tenant_comment: yup.string().required(),
    }),
    form: (props) => <UserInfo {...props} />,
  },
  {
    schema: yup.object().shape({
      tenant_proposal: yup.number().required(),
      payment_type: yup.string().required(),
      terms_and_condition: yup.boolean().required().oneOf([true], { translation: 'booking.paymentInfo.termsAndCondition.error' }),
    }),
    form: (props) => <PaymentStep {...props} />,
    handleOnSubmit: async (payload, { stripe, elements, property, hasCounteroffer, counterofferAccepted, booking }) => {
      Sentry.addBreadcrumb(`handleOnSubmit call`, ``, payload)
      Sentry.captureMessage(`submit request ${payload.id}`)
      if (hasCounteroffer && !counterofferAccepted) {
        Sentry.addBreadcrumb(`couunteroffer`, `not counterofferAccepted`)
        Sentry.captureMessage(`request ${payload.id} has counteroffer`)
        try {
          await Axios.put(`${process.env.REACT_APP_REJECT_COUNTEROFFER_API}/${payload.id}`, {})
          setTimeout(() => {
            window.location.href = `${process.env.REACT_APP_WEBSITE}`
          }, 2000)
          return { error: false, message: 'form.counterofferRejectedMessage' }
        } catch (e) {
          let { message } = e
          if (e.response && e.response.data && e.response.data.message) {
            message = e.response.data.message
          }
          Sentry.captureException(e)
          return { error: true, message }
        }
      }

      let token = { id: null }

      if (payload.payment_type !== 'bank_transfer' && booking.status === 'DRAFT') {
        Sentry.captureMessage(`request ${payload.id} payment type is not bank_transfer and status is DRAFT`)
        const createTokenResponse = await stripe.createToken(elements.getElement(CardNumberElement), {
          currency: property.currency,
        })
        if (createTokenResponse.error) {
          Sentry.captureException(createTokenResponse.error)
          return { error: true }
        }
        token = createTokenResponse.token
      }

      try {
        if (booking.status === 'PENDING') {
          await Axios.put(process.env.REACT_APP_BOOKING_API + '/update-pending', { ...payload })
        } else {
          await Axios.post(process.env.REACT_APP_CONFIRM_API, { ...payload, card_token: token.id })
        }

        if (hasCounteroffer && counterofferAccepted) {
          Sentry.addBreadcrumb(`couunteroffer`, `counterofferAccepted`)
          await Axios.put(`${process.env.REACT_APP_ACCEPT_COUNTEROFFER_API}/${payload.id}`, {})
        }
      } catch (e) {
        let { message } = e
        if (e.response && e.response.data && e.response.data.message) {
          message = e.response.data.message
        }
        if (e.response.data.error_code === 15) message = 'booking.paymentInfo.card.notSupported'

        return { error: true, message }
      }
      TagManager.dataLayer({
        dataLayer: {
          event: 'eec',
          category: 'checkout',
          action: 'book',
          label: `step 3`,
          ecommerce: {
            currencyCode: 'EUR',
            checkout: {
              actionField: {
                step: 3,
              },
              products: [
                {
                  id: toString(property.id),
                  price: toString(property.price),
                  brand: upperFirst(property.city),
                  category: property.type,
                  variant: '',
                  quantity: 1,
                  name: `${toLower(property.street)}, ${toLower(property.city)}, ${property.id}`,
                },
              ],
            },
          },
        },
      })
      TagManager.dataLayer({
        dataLayer: {
          event: 'eec',
          category: 'enhanced ecommerce',
          action: 'purchase',
          label: payload.id,
          ecommerce: {
            currencyCode: 'EUR',
            purchase: {
              actionField: {
                id: payload.id,
                affiliation: 'Zappyrent',
                revenue: payload.tenant_proposal,
                coupon: '',
              },
              products: [
                {
                  id: toString(property.id),
                  price: toString(property.price),
                  brand: upperFirst(property.city),
                  category: property.type,
                  variant: '',
                  quantity: 1,
                  name: `${toLower(property.street)}, ${toLower(property.city)}, ${property.id}`,
                },
              ],
            },
          },
        },
      })
      setTimeout(() => {
        window.location.href = `${process.env.REACT_APP_WEBSITE}/${language}/thankyou?booking_id=${payload.id}`
      }, 2000)
      // return {
      //   error: false,
      //   data: {
      //     token
      //   }
      // }
    },
  },
]
